import  axios from 'axios' ;

//axios.defaults.baseURL = "https://localhost/";
//axios.defaults.baseURL = "https://vue.canada-az-iran.com/";
axios.defaults.baseURL = window.location.origin;
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
axios.defaults.params = {language: 'fa'};